import { createAction } from '@reduxjs/toolkit';

const saveAccommodationSearchFormValues = createAction(
  'ui/sealink/accommodation/saveSearchFormValues'
);

const saveAccommodationSearchResults = createAction(
  'ui/sealink/accommodation/saveSearchResults'
);

const setAccommodationCurrentProvider = createAction(
  'ui/sealink/accommodation/setCurrentProvider'
);

const setAccommodationCurrentRoom = createAction(
  'ui/sealink/accommodation/setCurrentRoom'
);

const setAccommodationCurrentTotalPrice = createAction(
  'ui/sealink/accommodation/setCurrentTotalPrice'
);

export {
  saveAccommodationSearchFormValues,
  saveAccommodationSearchResults,
  setAccommodationCurrentProvider,
  setAccommodationCurrentRoom,
  setAccommodationCurrentTotalPrice,
};
